import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useEffect, useRef, useState } from "react";
import * as Config from "./ConfigurationRegistry";

/**
 * An extension to the useEffect hook which does not run on initial render (mount) - only on update.
 */
export function useDidMountEffect(func, deps) {
  var didMount = useRef(false);
  useEffect(function () {
    if (didMount.current) func();else didMount.current = true;
  }, deps);
}
;

/**
 * Hook which creates 'data' state which is bound to a configuration value uniquely identified by the path.
 *
 * @param path - configuration path which uniquely identifies the configuration value bound to this component
 */
export function useConfigurationData(path) {
  var _useState = useState(Config.fromPath(path, true).data),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];

  /**
   * When component is mounted, load the data from the registry.
   * Hook useDidMountEffect is used to avoid unnecessarily running on initial mount.
   */
  useDidMountEffect(function () {
    setData(Config.fromPath(path, true).data);
  }, [path]);

  /**
   * Whenever data changes, update the registry
   * Hook useDidMountEffect is used to avoid unnecessarily running on initial mount.
   */
  useDidMountEffect(function () {
    if (data) {
      Config.setData(path, data);
    }
  }, [data]);
  return [data, setData];
}

/**
 * Hook which creates 'value' state which is bound to a configuration value uniquely identified by the path.
 *
 * @param path - configuration path which uniquely identifies the configuration value bound to this component
 */

export function useConfigurationDataValue(path) {
  var _useState3 = useState(Config.fromPath(path, true).data.value),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];

  /**
   * When component is mounted, load the data from the registry
   * Hook useDidMountEffect is used to avoid unnecessarily running on initial mount.
   */
  useDidMountEffect(function () {
    setValue(Config.fromPath(path, true).data.value);
  }, [path]);

  /**
   * Whenever data changes, update the registry
   * Hook useDidMountEffect is used to avoid unnecessarily running on initial mount.
   */
  useDidMountEffect(function () {
    if (value !== null) {
      Config.setDataValue(path, value);
    }
  }, [value]);
  return [value, setValue];
}